import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Typography } from '@mui/material';
import { IoClose } from 'react-icons/io5';
// import { DeactivateFos } from 'API/fos_ist/api';

export default function StatusUpdateDialog(props) {


    // console.log("props",props);


    // const handleSubmit = () => {
    //     DeactivateFos(props.data._id, props.setIsLoading, props.handleAlertOpen, props.handleGet,props.handleClose);
    // }
    


    return (
        <React.Fragment>

            <Dialog
                open={props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <Typography variant='h3'>Confirmation</Typography>
                </DialogTitle>
                <Box sx={{ position: 'absolute', top: '0px', right: '0px', padding: '10px', cursor: 'pointer', fontSize: '22px' }} onClick={props.handleClose}>
                    <IoClose />
                </Box>
                <DialogContent sx={{ paddingBlock: 0 }}>
                    <DialogContentText id="alert-dialog-description">
                        Please confirm before proceeding with the status update.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                        variant='contained'
                        size='small'
                        disabled={props.isLoading}
                        sx={{
                            borderRadius: '8px',
                            backgroundColor: "#688B2A",
                            color: "#FFFFFF",
                            "&:hover": {
                                backgroundColor: "#688B2A",
                            },
                        }}
                        onClick={props.handleSubmit} autoFocus>
                        {props.isLoading?"Loading...":"Proceed"}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
